import React, { useEffect, useState, useCallback } from "react";
import API, { CONFIG, UPDATE_CONFIG } from "../../network/api";
import { TEXT_DEF } from "../../constant/text";
import { Button, InputNumber, message } from "antd";
import ModalCommon from "../../components/Modal";

const TEXT = {
    playLimit: "Số lượt chơi mỗi ngày",
    predictLimit: "Số lượt dự đoán mỗi trận",
    minDeposit: "Nạp tối thiểu",
    bettingRevenue: "Doanh thu cược",
    BanCa: 'BẮN CÁ',
    Slot: 'SLOTS',
    Casino: 'CASINO',
    GameViet: 'GAME VIỆT',
    TheThao: 'THỂ THAO',
    save: "Lưu",
}

function pickLimitTurns(data) {
    const v =
        data?.limitTurns ?? data?.maxTurns ?? data?.maxDailyTurns ?? 0;
    const n = Number(v);
    return Number.isNaN(n) ? 0 : n;
}

function pickMaxPredictionsPerMatch(data) {
    const v =
        data?.maxPredictionsPerMatch ??
        data?.maxPredictionTurns ??
        data?.maxPredictTurns ??
        data?.maxDailyPredictTurns ??
        data?.predictionTurnLimit ??
        0;
    const n = Number(v);
    return Number.isNaN(n) ? 0 : n;
}

const SetupCondition = () => {
    const [isShowModalConfirm, setIsShowModalConfirm] = useState(false);
    const [isShowModalSuccess, setIsShowModalSuccess] = useState(false);

    // State
    const [maxTurn, setMaxTurn] = useState(0);
    const [maxPredictionTurns, setMaxPredictionTurns] = useState(0);
    const [minDeposit, setMinDeposit] = useState(0); // Chỉ dùng 1 biến minDeposit chung

    // State DTC (Doanh thu cược)
    const [dtcBanCa, setDTCBanCa] = useState(0);
    const [dtcSlot, setDTCSlot] = useState(0);
    const [dtcCasino, setDTCCasino] = useState(0);
    const [dtcGameViet, setDTCGameViet] = useState(0);
    const [dtcTheThao, setDTCTheThao] = useState(0);

    const [messageApi, contextHolder] = message.useMessage();

    const showError = useCallback((errorMessage) => {
        messageApi.open({
            type: 'error',
            content: errorMessage,
        });
    }, [messageApi]);

    const getDataConfig = useCallback(async () => {
        try {
            const res = await API.get(`${CONFIG}`);
            const data = res.data?.data || res.data;
            
            // Xử lý dữ liệu cũ nếu cấu trúc BE chưa đổi kịp (flatten dữ liệu)
            // Ưu tiên lấy ở root, nếu không có thì fallback vào các phase cũ để hiển thị
            const savedMinDeposit = data?.minDeposit || data?.playPhases?.phase1?.minDeposit || data?.playPhases?.phase2?.minDeposit || 0;
            
            // Lấy DTC requirements (ưu tiên root -> fallback phase 2 cũ)
            const dtcRequirements = data?.dtcRequirements || data?.playPhases?.phase2?.dtcRequirements || {};

            setMinDeposit(savedMinDeposit);
            setDTCBanCa(dtcRequirements[3] || dtcRequirements['3'] || 0);
            setDTCSlot(dtcRequirements[1] || dtcRequirements['1'] || 0);
            setDTCCasino(dtcRequirements[4] || dtcRequirements['4'] || 0);
            setDTCGameViet(dtcRequirements[2] || dtcRequirements['2'] || 0);
            setDTCTheThao(dtcRequirements[5] || dtcRequirements['5'] || 0);
            
            setMaxTurn(pickLimitTurns(data));
            setMaxPredictionTurns(pickMaxPredictionsPerMatch(data));
        } catch (err) {
            console.log(err);
            showError("Không thể tải dữ liệu cấu hình");
        }
    }, [showError]);

    useEffect(() => {
        getDataConfig();
    }, [getDataConfig]);

    const handleChangeInput = (value, key) => {
        switch (key) {
            case "minDeposit":
                setMinDeposit(value);
                return;
            case "maxTurn":
                setMaxTurn(value);
                return;
            case "maxPredictionTurns":
                setMaxPredictionTurns(value);
                return;
            case "dtcBanCa":
                setDTCBanCa(value);
                return;
            case "dtcSlot":
                setDTCSlot(value);
                return;
            case "dtcCasino":
                setDTCCasino(value);
                return;
            case "dtcGameViet":
                setDTCGameViet(value);
                return;
            case "dtcTheThao":
                setDTCTheThao(value);
                return;
            default:
                return;
        }
    };

    const handleUpdateConfig = async () => {
        try {
            setIsShowModalConfirm(false);

            if (
                !validNumber(minDeposit) ||
                !validNumber(maxTurn) ||
                !validNumber(maxPredictionTurns) ||
                !validNumber(dtcBanCa) ||
                !validNumber(dtcSlot) ||
                !validNumber(dtcCasino) ||
                !validNumber(dtcGameViet) ||
                !validNumber(dtcTheThao)
            ) {
                showError("Vui lòng nhập số hợp lệ");
                return;
            }

            // Tạo cấu trúc config mới phẳng hơn (không còn lồng nhau phase1/phase2)
            const config = {
                minDeposit: parseInt(minDeposit),
                limitTurns: parseInt(maxTurn),
                maxPredictionsPerMatch: parseInt(maxPredictionTurns),
                dtcRequirements: {
                    1: parseInt(dtcSlot),
                    2: parseInt(dtcGameViet),
                    3: parseInt(dtcBanCa),
                    4: parseInt(dtcCasino),
                    5: parseInt(dtcTheThao),
                },
            };

            const body = {
                config: config,
            };
            
            await API.patch(`${UPDATE_CONFIG}`, body);
            setIsShowModalSuccess(true);
            
            // Reload data sau khi update thành công
            setTimeout(() => {
                getDataConfig();
            }, 1000);
        } catch (err) {
            console.log(err);
            showError(err?.response?.data?.message || "Cập nhật cấu hình thất bại");
            setIsShowModalSuccess(false);
        }
    };

    const validNumber = (value) => {
        if (value === undefined || value === null || value === "") {
            return false;
        }
        const number = parseInt(value);
        return !isNaN(number) && number >= 0; // Cho phép số 0 nếu cần thiết
    }

    const handleShowModal = () => {
        setIsShowModalConfirm(true);
    };

    const rowStyle = {
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 12,
        width: "100%",
        minHeight: 48,
        paddingTop: 12,
        paddingBottom: 12,
    };

    const labelStyle = {
        flex: "1 1 auto",
        minWidth: 0,
        textAlign: "left",
        fontWeight: 500,
        fontSize: 14,
        color: "rgba(0,0,0,0.88)",
        paddingRight: 12,
    };

    const inputWrapStyle = {
        width: 260,
        maxWidth: "min(260px, 46vw)",
        flexShrink: 0,
    };

    const renderInputNumber = (key, defaultValue, changeInput, max, label) => (
        <div style={rowStyle}>
            <span style={labelStyle}>{label}</span>
            <div style={inputWrapStyle}>
                <InputNumber
                    key={key}
                    style={{ width: "100%" }}
                    value={defaultValue}
                    onChange={changeInput}
                    max={max}
                    min={0}
                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                    controls
                />
            </div>
        </div>
    );

    /** Mỗi khối (ô) có viền riêng */
    const renderBorderedBox = (children) => (
        <div
            style={{ marginBottom: 24 }}
            className="w-full rounded-lg border border-gray-300 bg-white p-4 shadow-sm"
        >
            {children}
        </div>
    );

    return (
        <div className="col-12">
            {contextHolder}
            {minDeposit !== undefined && (
                <div className="col-12 mx-auto w-full max-w-3xl px-3 pb-8 sm:px-4">
                    <div className="flex w-full flex-col">
                        {/* Wireframe: hai ô giới hạn nằm trên, ngoài khung */}
                        <div style={{ marginBottom: 24 }} className="w-full">
                            {renderInputNumber(
                                "maxTurn",
                                maxTurn,
                                (v) => handleChangeInput(v, "maxTurn"),
                                1000000,
                                TEXT.playLimit
                            )}
                            {renderInputNumber(
                                "maxPredictionTurns",
                                maxPredictionTurns,
                                (v) => handleChangeInput(v, "maxPredictionTurns"),
                                1000000,
                                TEXT.predictLimit
                            )}
                        </div>

                        {renderBorderedBox(
                            renderInputNumber(
                                "minDeposit",
                                minDeposit,
                                (v) => handleChangeInput(v, "minDeposit"),
                                1000000000,
                                TEXT.minDeposit
                            )
                        )}

                        {renderBorderedBox(
                            <>
                                <div className="mb-3 border-b border-gray-200 pb-2 text-base font-bold text-gray-700">
                                    {TEXT.bettingRevenue}
                                </div>
                                {renderInputNumber(
                                    "dtcBanCa",
                                    dtcBanCa,
                                    (v) => handleChangeInput(v, "dtcBanCa"),
                                    1000000000,
                                    TEXT.BanCa
                                )}
                                {renderInputNumber(
                                    "dtcSlot",
                                    dtcSlot,
                                    (v) => handleChangeInput(v, "dtcSlot"),
                                    1000000000,
                                    TEXT.Slot
                                )}
                                {renderInputNumber(
                                    "dtcCasino",
                                    dtcCasino,
                                    (v) => handleChangeInput(v, "dtcCasino"),
                                    1000000000,
                                    TEXT.Casino
                                )}
                                {renderInputNumber(
                                    "dtcGameViet",
                                    dtcGameViet,
                                    (v) => handleChangeInput(v, "dtcGameViet"),
                                    1000000000,
                                    TEXT.GameViet
                                )}
                                {renderInputNumber(
                                    "dtcTheThao",
                                    dtcTheThao,
                                    (v) => handleChangeInput(v, "dtcTheThao"),
                                    1000000000,
                                    TEXT.TheThao
                                )}
                            </>
                        )}
                    </div>
                    <div
                        style={{
                            marginTop: 32,
                            paddingTop: 8,
                            display: "flex",
                            width: "100%",
                            justifyContent: "flex-end",
                        }}
                    >
                        <Button type="primary" onClick={handleShowModal} size="large">
                            {TEXT.save}
                        </Button>
                    </div>
                </div>
            )}
            {isShowModalConfirm && (
                <ModalCommon
                    isShow={isShowModalConfirm}
                    message={TEXT_DEF.text0062}
                    txtBtnAcc={TEXT_DEF.text0008}
                    textBtnClose={TEXT_DEF.text0023}
                    actionNext={handleUpdateConfig}
                    close={() => setIsShowModalConfirm(false)}
                />
            )}
            {isShowModalSuccess && (
                <ModalCommon
                    isShow={isShowModalSuccess}
                    message={TEXT_DEF.text0063}
                    txtBtnAcc={TEXT_DEF.text0007}
                    actionNext={() => {
                        setIsShowModalSuccess(false);
                        getDataConfig();
                    }}
                    close={() => {
                        setIsShowModalSuccess(false);
                        getDataConfig();
                    }}
                />
            )}
        </div>
    );
};

export default SetupCondition;